import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Dropzone from "dropzone";
import { showToast } from "@Shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DropzoneSection",
  props: {
    maxFiles: {
      type: Number,
      default: null
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    showFilesQuantity: {
      type: Boolean,
      default: false
    },
    showFilesNames: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropzone: {},
      VALID_DOCUMENTS_EXTENSIONS: ["pdf", "doc", "docx"],
      VALID_IMAGES_EXTENSIONS: ["jpg", "jpeg", "png", "tiff"],
      addingFiles: false
    };
  },
  computed: {
    files() {
      var _this$dropzone$files, _this$dropzone;
      return (_this$dropzone$files = (_this$dropzone = this.dropzone) == null ? void 0 : _this$dropzone.files) != null ? _this$dropzone$files : [];
    },
    filesNames() {
      var _context;
      return _mapInstanceProperty(_context = this.files).call(_context, file => {
        var _file$name;
        return (_file$name = file.name) != null ? _file$name : file.fileName;
      });
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.dropzone = new Dropzone(this.$refs.dropzone, {
        url: "/",
        maxFiles: this.maxFiles,
        thumbnailHeight: 30,
        thumbnailWidth: 30,
        autoProcessQueue: false,
        method: "put",
        maxFilesize: 25,
        clickable: false,
        sending: (file, xhr) => {
          //monkey patch for avoiding multipart/form-data
          const _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, file);
          };
        },
        acceptFiles: "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
        accept: (file, done) => {
          const extension = file.name.split(".").pop();
          if (this.isValidExtension(extension)) done();else done("File type not supported.");
        }
      });
      this.dropzone.on("addedfile", this.addedFile);
      this.dropzone.on("addedfiles", this.addedFiles);
    },
    isValidExtension(extension) {
      var _context2, _context3;
      if (_includesInstanceProperty(_context2 = this.VALID_DOCUMENTS_EXTENSIONS).call(_context2, extension.toLowerCase())) return "document";else if (_includesInstanceProperty(_context3 = this.VALID_IMAGES_EXTENSIONS).call(_context3, extension.toLowerCase())) return "image";else return false;
    },
    addedFile(file) {
      if (!this.addingFiles) {
        if (this.isValidExtension(file.name.split(".").pop())) this.$emit("added-file", [file]);else this.handleUnsupportedFile();
      }
    },
    addedFiles(filesAdded) {
      const files = _Array$from(filesAdded);
      if (files.every(file => this.isValidExtension(file.name.split(".").pop()))) this.$emit("added-files", files);else this.handleUnsupportedFile();
    },
    removeFile(file) {
      this.dropzone.removeFile(file);
      this.$refs.fileInput.value = null;
    },
    removeAllFiles(emit) {
      if (emit) this.$emit("removed-all-files");
      this.dropzone.removeAllFiles();
      this.$refs.fileInput.value = null;
    },
    handleFilesSelected(event) {
      var _event$target;
      const files = (event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.files) || [];
      if (files.length > 0) {
        this.addingFiles = true;
        files.forEach(file => this.dropzone.addFile(file));
        this.addedFiles(files);
        this.addingFiles = false;
      }
    },
    handleUnsupportedFile() {
      showToast("error", "fileTypeNotSupported");
      this.removeAllFiles(true);
    }
  }
});